import { render } from "./AssistantPeek.vue?vue&type=template&id=b6a0b3ac&scoped=true"
import script from "./AssistantPeek.vue?vue&type=script&lang=js"
export * from "./AssistantPeek.vue?vue&type=script&lang=js"

import "./AssistantPeek.vue?vue&type=style&index=0&id=b6a0b3ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a0b3ac"]])

export default __exports__